// extracted by mini-css-extract-plugin
export default {"first":"MainBox_first__ML3pw","second":"MainBox_second__Ma8oI","group":"MainBox_group__7rITb","simage":"MainBox_simage__UzyQR"};